import { View } from 'react-native'
import cn from '@ui/utils/cn'

export const ModalButtons = ({ children }: { children: React.ReactNode }) => {
  return (
    <View
      className={cn(
        'w-full flex-1 flex-row items-center justify-between gap-8 px-16 pb-16 pt-12'
        // center && 'justify-center gap-16'
      )}
    >
      {children}
    </View>
  )
}
